<template >
  <div>
    <template v-for="report in list">
      <ItemTitle :key="report.key" :title="report.name"></ItemTitle>
      <StateanAlysis
        :key="item.id"
        v-for="item in ReportData[report.key]"
        :item="item"
      ></StateanAlysis>
    </template>
    <HealthReport></HealthReport>
  </div>
</template>

<script>
import ItemTitle from "../title.vue";
import StateanAlysis from "./stateanalysis.vue";
import HealthReport from "../health/index.vue";
export default {
  props: ["list"],
  components: {
    ItemTitle,
    StateanAlysis,
    HealthReport,
  },
  computed: {
    ReportData() {
      return this.$store.state.ReportData;
    },
  },
};
</script>

<style>
</style>